jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    //START -> HOMEPAGE PZ DIV
    $("#pz-wrapper .close-mark").click(function() {
        $("#pz-wrapper").addClass("closed");
    });
    //END -> HOMEPAGE PZ DIV

    $(".search-field").focusin(function() {
        $(this).addClass('active');
    });

    $(".search-field").focusout(function() {
        $(this).removeClass('active');
    });

    $('#menu-toggle').on('click', function() {
        $('#menu-toggle').toggleClass('active');
        $('#whitewrap').toggleClass('open-menu');
    });

    $('.search-toggle-button').on('click', function() {
        $('#search-toggle').toggleClass('active');
        $('#menu-toggle').removeClass('active');
        $('#alg-search').typeahead('close');
    });

    $('#alg-search').on('input', function(e) {
        $(this).off('blur');
    });

    if ('body.home') {
        $("#tabs").tabs({
            'create': function(e, ui) { // for first tab content
                if (typeof LazyLoad === "function") {
                    var myLazyLoad = new LazyLoad();
                }
            },
            'activate': function(e, ui) { // when additional tabs are clicked and shown-
                if (typeof LazyLoad === "function") {
                    var myLazyLoad = new LazyLoad(); 
                }
            }
        });
    }

    $(".mobile-tab-4 .mobile-tab-label").attr("data-override","true");
    jQuery('.mobile-tab-4 .mobile-tab-label').off('click').on('click', function (e) {
       e.preventDefault();
        window.location = "tel:+3303418878";
    });

    // $("body").on("vrp-ready vrp-ajax-complete",function() {
    //     $(".vehicle").each(function() {
    //         $(this).find($('.vehicle-image a')).prepend('<img class="img-overlay" src="https://di-uploads-pod2.dealerinspire.com/kiaofstreetsboro/uploads/2022/03/kos-new-march.png" />');
    //     });
    // });
    // $('.vdp-gallery-wrap .swiper-slide').prepend('<img class="img-overlay" src="https://di-uploads-pod2.dealerinspire.com/kiaofstreetsboro/uploads/2022/03/kos-new-march.png" />');

    // 01187101

    // homepage tagging
    $('a.di-slider-link[href="https://www.kiaofstreetsboro.com/lease-return-center/"]').attr('name', 'lease-return-center');
    $('a.di-slider-link[href="https://www.kiaofstreetsboro.com/used-vehicles/"]').attr('name', 'used-vehicles');
    $('a.di-slider-link[href="https://www.kiaofstreetsboro.com/3-day-exchange/"]').attr('name', '3-day-exchange');
    $('a.di-slider-link[href="https://www.kiaofstreetsboro.com/new-vehicles/"]').attr('name', 'new-vehicles');

    $('#1-section .model-box:first-child a').attr('name', 'new-vehicles-stinger');
    $('#1-section .model-box:nth-child(2) a').attr('name', 'new-vehicles-forte');
    $('#1-section .model-box:nth-child(3) a').attr('name', 'new-vehicles-k5');

    $('#2-section .model-box:first-child a').attr('name', 'new-vehicles-carnival');
    $('#2-section .model-box:nth-child(2) a').attr('name', 'new-vehicles-soul');
    $('#2-section .model-box:nth-child(3) a').attr('name', 'new-vehicles-seltos');
    $('#2-section .model-box:nth-child(4) a').attr('name', 'new-vehicles-sportage');
    $('#2-section .model-box:nth-child(5) a').attr('name', 'new-vehicles-sorento');
    $('#2-section .model-box:nth-child(6) a').attr('name', 'new-vehicles-niro');
    $('#2-section .model-box:nth-child(7) a').attr('name', 'new-vehicles-telluride');

    $('#3-section .model-box:first-child a').attr('name', 'new-vehicles-rio');
    $('#3-section .model-box:nth-child(2) a').attr('name', 'new-vehicles-rio-5-door');

    $('#4-section .model-box:first-child a').attr('name', 'new-vehicles-niro-ev');
    $('#4-section .model-box:nth-child(2) a').attr('name', 'new-vehicles-niro-plug-in-hybrid');

    $('#serviceRow a.button.primary-button.home').attr('name', 'schedule-service');
    $('#incentivesRow a.button.primary-button.home').attr('name', 'offers-incentives');
    $('#certifiedRow a.button.primary-button.home').attr('name', 'view-certified-vehicles');

    // vrp tagging
    $('input.small.button.im-reset-filters.hidden-xs.hidden-mobile').attr('name', 'sidebar-filter-reset-search');
    $('input.small.button.im-reset-filters.visible-xs.hidden-desktop.hidden-tablet').attr('name', 'sidebar-filter-reset');
    $('input.small.button.im-share-vrp.hidden-xs.hidden-mobile').attr('name', 'sidebar-filter-share-results');
    $('input.small.button.groupon-mobile-filters-toggle.visible-xs').attr('name', 'sidebar-filter-hide');
    $('input.small.button.groupon-mobile-filters-apply.visible-xs').attr('name', 'sidebar-filter-view-results');

    $('#results-page td.gridview .vehicle.grid-view .button-bar .primary-cta.cta-approved a').attr('name', 'widget-vehicle-apply-for-financing');
    $('#results-page td.gridview .vehicle.grid-view .button-bar .primary-cta.cta-trade a').attr('name', 'widget-vehicle-sell-or-trade-your-car');
    $('#results-page td.gridview .vehicle.grid-view .button-bar .primary-cta a[href="#gravity-form-1"]').attr('name', 'widget-vehicle-get-e-price');

    

    





     

});

